import ProviderPageLeftPart from '../../../components/ProviderPage/ProviderPageLeftPart/ProviderPageLeftPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(ProviderPageLeftPart);
